"use client";

import { useLocale } from "next-intl";
import LocaleSwitcherSelect from "../components/localeSwitcherSelect";
import { locales } from "@i18n";

export default function LocaleSwitcher() {
  const locale = useLocale();

  return (
    <LocaleSwitcherSelect defaultValue={locale} label="swtich">
      {locales.map((cur) => (
        <option key={cur} value={cur}>
          {cur}
        </option>
      ))}
    </LocaleSwitcherSelect>
  );
}
